export default "__VITE_ASSET__RkQPQe9Z__ 100w";